import { Box, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { fetchpromptdataApi, getAllPropmtDataApi } from "../../../allApi/api";
import { useCustomTost } from "../../../utiils/useCustomTost";
import PromptListItem from "./PromptListItem";
import { useSelector } from "react-redux";
import PromptSkeletonAgentData from "../../../components/loader/skeletonLoader/AgentEvalution/PromptListSkeleton";

function PropmtList() {
  const toast = useCustomTost();
  const [promptData, setpromptData] = useState([]);
  const savePromptList = useSelector(
    (state) => state.promptTesting.savePromptData
  );
  const [promptListLoader, setPromptListLoader] = useState(false);
  const getAllPrompt = async () => {
    try {
      setPromptListLoader(true);
      const res = await getAllPropmtDataApi();
      setpromptData(res?.data);
    } catch (error) {
      toast("An error occurred.", error, "error");
    } finally {
      setPromptListLoader(false);
    }
  };
  useEffect(() => {
    getAllPrompt();
  }, [savePromptList]);
  return (
    <Box h={"100%"} w={"16%"}>
      <Box h={"50px"} borderBottom={"1px solid #E4E4E7"} p={2}>
        <Text fontWeight={"bold"}>Prompts</Text>
      </Box>
      <Box p={3}>
        {promptListLoader ? (
          <PromptSkeletonAgentData />
        ) : (
          <PromptListItem promptData={promptData} />
        )}
      </Box>
    </Box>
  );
}

export default PropmtList;
